import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analyticsClient";

/**
 * Fires a pageview beacon on every React Router navigation. Must live INSIDE
 * <BrowserRouter> so it can call useLocation. Renders nothing.
 */
export default function AnalyticsListener() {
  const location = useLocation();
  useEffect(() => {
    // Skip /admin — never track admin routes to avoid inflating stats.
    if (location.pathname.startsWith("/admin")) return;
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}
